


























































































































































































































import DeviceUnassignBtn from '../components/DeviceUnassignBtn.vue';
import DeviceResetSubscriptionToBaseBtn from '../components/DeviceResetSubscriptionToBaseBtn.vue';
import DeviceSyncConfigBtn from './DeviceSyncConfigBtn.vue';
import DevicePinCodeUpdateBtn from './DevicePinCodeUpdate.vue';
import DeviceDeleteBtn from './DeviceDeleteBtn.vue';
import BatteryLevel from '../components/BatteryLevel.vue';
import { deviceApi } from '../device.api';
import BaseTable from '@/modules/core/components/BaseTable';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  components: {
    DeviceDeleteBtn,
    DeviceUnassignBtn,
    DeviceResetSubscriptionToBaseBtn,
    DeviceSyncConfigBtn,
    DevicePinCodeUpdateBtn,
    BatteryLevel,
  },
})
export default class DevicesTable extends BaseTable {
  @Prop()
  public ownerId?: string;

  public protectionStatuses = [
    {
      id: undefined,
      label: '',
    },
    {
      id: true,
      label: 'Activée',
    },
    {
      id: false,
      label: 'Désactivée',
    },
  ];

  public async fetchData(): Promise<any> {
    return await deviceApi.findAll({
      ...this.pagination,
      ...this.filters,
      sort: this.sort,
    });
  }

  public buildFilters(gridFilters: any): void {
    this.$super(BaseTable).buildFilters(gridFilters);

    if (this.ownerId) {
      this.filters.ownerId = this.ownerId;
    }
  }

  public get exportUrl(): string {
    return deviceApi.getExportUrl();
  }
}
